import React, { useState } from "react";
import Login from "./Login";
import Dashboard from "./Dashboard";
import "./App.css";

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [dark, setDark] = useState(true); // default dark mode

  return (
    <div className="App">
      {loggedIn ? (
        <Dashboard
          onLogout={() => setLoggedIn(false)}
          dark={dark}
          setDark={setDark}
        />
      ) : (
        <Login onLogin={() => setLoggedIn(true)} />
      )}
    </div>
  );
}

export default App;